var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatedAt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1694488945708,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 39963,
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 895.936c-211.776 0-384-172.224-384-384C128 300.224 300.16 128 512 128c211.648 0 384 172.288 384 384a32 32 0 1 0 64 0C960 264.96 759.04 64 512 64 265.216 64 64 264.96 64 512c0 246.912 201.024 447.936 448 447.936a32 32 0 0 0 0-64zM512 190.912a32 32 0 0 0-32.064 32.064v275.776L361.28 617.344a32 32 0 0 0 45.312 45.248L534.208 535.04a30.912 30.912 0 0 0 5.184-6.72s0-0.128 0.128-0.128l0.64-1.152c0-0.128 0.128-0.128 0.128-0.192l0.64-1.216v-0.192c0.256-0.448 0.512-0.832 0.512-1.216 0-0.064 0.192-0.064 0.192-0.192l0.448-1.28 0.128-0.256c0.064-0.384 0.32-0.768 0.384-1.28l0.128-0.192 0.256-1.28c0-0.128 0-0.192 0.128-0.192a26.24 26.24 0 0 0 0.384-1.664c0.128-0.32 0.128-0.768 0.192-1.152 0-0.192 0-0.32 0.128-0.512l0.064-1.088c0-0.256 0-0.448 0.128-0.704l0.064-0.832v-290.56a32.128 32.128 0 0 0-32.064-32z m415.552 544.96h-127.872v-128a32 32 0 1 0-64.064 0v128h-128a32 32 0 1 0 0 64.064h128.064v128a32 32 0 0 0 64 0v-128.064h128.064a32 32 0 0 0 32.064-32.064 32.32 32.32 0 0 0-32.256-31.936z",
    fill: "currentColor",
    "p-id": 39964
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedAt);
export default __webpack_public_path__ + "static/media/created-at.5f17a2ba65b0234c61214d7106e0fb2e.svg";
export { ForwardRef as ReactComponent };